import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {DungeonQuestSymbolUtil} from "../../utils/DungeonQuestSymbolUtil";
import {DungeonQuestGameConfig} from "../DungeonQuestGameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Timeline, TimelineLite} from "gsap"
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";

/**
 * Created by Jonas Wålekvist on 2018-05-03.
 */


export class DungeonQuestRandomFeatureBaseController extends ReelStopPresentationController {
    protected _mode:string;
    protected _nextMode:string;
    protected _introAnimation:TimelineLite | null;
    private _shouldShow:boolean;

    constructor(index:number, name:string) {
        super(index, name);
    }

    protected hasWin() {
        return false;
    }

    protected parseFeatureSpecificGameData?(data:ParsedGameData):void;

    protected parseFeatureGameData(data:ParsedGameData):void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        if(this.hasWin()) {
            this._shouldShow = true;
            if(this.parseFeatureSpecificGameData) {
                this.parseFeatureSpecificGameData(data)
            }
        }
        this.tryToStart();
    }

    protected getIntroFeatureAnimation?():TimelineLite;

    private tryToStart() {
        if(this._shouldShow) {
            this._introAnimation = new TimelineLite();

            if(this.getIntroFeatureAnimation) {
                this._introAnimation.add(this.getIntroFeatureAnimation());
            }
            this._introAnimation.add(() => this.reset());

            this.dispatchAddStopDelay();
        }
    }

    private dispatchAddStopDelay(){
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.ADD_STOP_DELAY,this.remainingDuration()));
    }

    public remainingDuration():number {
        let delay:number = this._introAnimation ? (this._introAnimation.totalDuration() - this._introAnimation.time()) : 0;
        if(this.hasWin()) {
            delay += 0.4;
        }
        return delay;
    }

    protected resetFeature():void {
        if(this._introAnimation) {
            this._introAnimation.kill();
            this._introAnimation = null;
        }
        this._shouldShow = false;
    }

    protected getSymbolOverlayAttentionAnimations(reelId:number, overlayPositions:[number, number][]):Timeline[] {
        const symbols:StateReelSymbol[] = [];

        for(let position of overlayPositions) {
            if(position[0] == reelId) {
                const symbol = Reels.getSymbol(position[0], position[1]);
                if(symbol) {
                    symbols.push(symbol)
                }
            }
        }

        return DungeonQuestSymbolUtil.getSymbolStateAnimations(symbols, DungeonQuestGameConfig.instance.SYMBOL_STATES.attention);
    }
}